module.exports = __webpack_public_path__ + "static/media/sketch@3x.67ba00e6.png";